<script lang="ts">
import type { Placement } from '@popperjs/core'
import { getContext, type Snippet } from 'svelte'

import Tooltip from '@/components/Tooltip.svelte'
import { contentListItemKey, type WritableMessageContext } from '@/modules/messages'
import { getAutoDateFormatter } from '@/utils/date'

type Props = {
	createdAt: string
	children?: Snippet
}

let { createdAt, children }: Props = $props()

let context = $derived(getContext<WritableMessageContext>(contentListItemKey))
let { align } = $derived($context.group)

let createdAtDate = $derived(new Date(createdAt))

let formatter: Intl.DateTimeFormat = $derived(getAutoDateFormatter(createdAtDate))

let placement: Placement = $derived(align.isLeft ? 'top-start' : 'top-end')
</script>

<Tooltip content={formatter.format(createdAtDate)} {placement} variant="light" isDisabledForTouchDevices={false}>
	{@render children?.()}
</Tooltip>
